<template>
  <div class="side_bar_container">
    <input id="menuopen-input" type="checkbox">
    <div class="side_bar closed">
      <label for="menuopen-input">
        <img class="img-item-side-bar" src="../../assets/icon/menu.png" />
      </label>
    </div>
    <div class="side_bar">
      <div class="opened">
        <label for="menuopen-input">
          <img class="img-item-side-bar" src="../../assets/icon/menu.png" />
        </label>
      </div>
      <div class="title">■ 予約メニュー</div>
      <router-link :to="{name: 'pending-meetings'}" class="item"
        onclick="document.getElementById('menuopen-input').checked = false"
        >
          <img class="img-item-side-bar" src="../../assets/icon/list.png" alt="">
          <span>未承認一覧</span>
      </router-link>
      <router-link :to="{name: 'home'}" class="item"
        onclick="document.getElementById('menuopen-input').checked = false"
        >
          <img class="img-item-side-bar" src="../../assets/icon/list.png" alt="">
          <span>予約一覧</span>
      </router-link>
      <router-link v-if="this.$auth.user().type === USER_TYPE_PHARMACIST && this.$auth.user().manager_flg" :to="{name: 'calendars.settings'}" class="item"
        onclick="document.getElementById('menuopen-input').checked = false"
        >
          <img class="img-item-side-bar" src="../../assets/icon/settings.png" alt="">
          <span>受付枠設定</span>
      </router-link>
      <router-link v-if="this.$auth.user().type === USER_TYPE_PHARMACIST" :to="{name: 'calendars'}" class="item"
        onclick="document.getElementById('menuopen-input').checked = false"
        >
          <img class="img-item-side-bar" src="../../assets/icon/calendar.png" alt="">
          <span>服薬指導予定表</span>
      </router-link>
      <router-link :to="{name: 'meetings.create'}" class="item"
        onclick="document.getElementById('menuopen-input').checked = false"
        >
        <img class="img-item-side-bar" src="../../assets/icon/calendar-plus.png" alt="">
        <span v-if="this.$auth.user().type === USER_TYPE_PHARMACIST">予約</span>
        <span v-if="this.$auth.user().type !== USER_TYPE_PHARMACIST">予約申請</span>
      </router-link>
      <div v-if="this.$auth.user().enable_askpay">
        <div class="border-line"></div>
        <div class="title">■ 決済メニュー</div>
        <div class="item"
          :class="{'is-disabled': isLoading}"
          @click.stop="getInvoiceInfo"
          >
            <img class="img-item-side-bar" src="../../assets/icon/cash.png" alt="">
            <span v-if="this.$auth.user().type === USER_TYPE_PHARMACIST">請求一覧</span>
            <span v-if="this.$auth.user().type === USER_TYPE_PATIENT">支払一覧</span>
        </div>
        <div v-if="this.$auth.user().type === USER_TYPE_PATIENT">
          <a class="item"
            :class="{'is-disabled': isLoading}"
            @click.stop="getShippingAddressInfo"
            >
              <img class="img-item-side-bar" src="../../assets/icon/address.png" alt="">
              配送先管理
          </a>
          <a class="item"
            :class="{'is-disabled': isLoading}"
            @click.stop="getCardInfo"
            >
              <img class="img-item-side-bar" src="../../assets/icon/card.png" alt="">
              カード情報管理
          </a>
        </div>
      </div>
    </div>
    
    <ShowModaler
        v-model="showModal"
        :iframeName="modalName"
        :iframeSrc="''" ref="sidebarModal"
        />

    <NoticeViewer />
  </div>
</template>

<script>
import {USER_TYPE_PHARMACIST, USER_TYPE_PATIENT} from '@/const'
import UsersApi from '@/api/users'
import PharmaciesApi from '@/api/pharmacies'
import {apiErrorDialog} from '@/helpers'
import axios from 'axios'
import ShowModaler from '@/components/ShowModaler'
import NoticeViewer from '@/components/NoticeViewer'

export default {
  components: {ShowModaler, NoticeViewer},
  watch: {
    showModal (val) {
      if (!val) {
        this.isLoading = false
      }
    }
  },
  data () {
    return {
      USER_TYPE_PHARMACIST,
      USER_TYPE_PATIENT,
      showModal: false,
      modalName: 'sidebar_iframe',
      info: {},
      isLoading: false,
    }
  },
  methods: {
    async getInvoiceInfo () {
      if (this.isLoading) return
      this.isLoading = true
      const headers = {
        'Authorization': `Bearer ${this.$auth.token()}`
      }
      try {
        if (this.$auth.user().type === USER_TYPE_PHARMACIST) {
          const getClaimantsInvoiceIndex = await PharmaciesApi.getClaimantsInvoiceIndex(headers)
          this.info = getClaimantsInvoiceIndex.data.data
        } else {
          const getCustomersInvoiceIndex = await UsersApi.getCustomersInvoiceIndex(headers)
          this.info = getCustomersInvoiceIndex.data.data
        }
        this.setUrl(this.info.url, this.info.token)
      } catch (error) {
        this.isLoading = false
        apiErrorDialog(this, error)
      }
    },
    async getShippingAddressInfo () {
      if (this.isLoading) return
      this.isLoading = true
      const headers = {
        'Authorization': `Bearer ${this.$auth.token()}`
      }
      try {
        const getEditingShippingAddressInfo = await UsersApi.getEditingShippingAddressInfo(headers)
        this.info = getEditingShippingAddressInfo.data.data
        this.setUrl(this.info.url, this.info.token)
      } catch (error) {
        this.isLoading = false
        apiErrorDialog(this, error)
      }
    },
    async getCardInfo () {
      if (this.isLoading) return
      this.isLoading = true
      const headers = {
        'Authorization': `Bearer ${this.$auth.token()}`
      }
      try {
        const getEditingCardInfo = await UsersApi.getEditingCardInfo(headers)
        this.info = getEditingCardInfo.data.data
        this.setUrl(this.info.url, this.info.token)
      } catch (error) {
        this.isLoading = false
        apiErrorDialog(this, error)
      }
    },
    async setUrl (url, token) {
      this.showModal = true
      var xhr = new XMLHttpRequest()

      if (url) {
        xhr.open('GET', url)
        xhr.onreadystatechange = handler
        xhr.responseType = 'blob'
        xhr.setRequestHeader('Authorization', `Bearer ${token}`)
        xhr.withCredentials = true
        xhr.send()
      }

      const self = this
      function handler () {
        if (this.readyState === this.DONE) {
          const dataUrl = URL.createObjectURL(this.response)
          document.querySelector('#' + self.modalName).src = dataUrl
        }
      }
    },
    closeModal () {
      this.showModal = false
      document.querySelector('#' + this.modalName).src = ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/layouts/Sidebar.vue